import ReactStrapTable from 'components/reactStrapTable';
import React, { useState } from 'react'
import Download from 'assets/icon/Download.svg';
import DownloadHover from "assets/icon/Download-icon-hover.svg";
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { onExport } from 'utils/helper';
import { toast } from 'react-toastify'
import useAxios from 'hooks/useAxios';
import collapse from 'assets/icon/collapse-icon.svg';
import collapseclose from 'assets/icon/collapse-icon-close.svg';
import Filters from 'components/Filters';
import Autosend from 'assets/icon/Autosend-reports-icon.svg';
import AutosendHover from "assets/icon/Esp-download-hover-icon.svg";


let tableDataBackup = [];

const ReportsTable = (props) => {

    const {
        manvalConfigedit,
        sort,
        setSort,
        manvalConfig,
        manvalPharmacy,
        collapseSider,
        manval,
        reportsdata,
        filters,
        totalSize,
        onPageChange,
        onSearch,
        setFilterShow,
        filtershow,
        selectedValues,
        setSelectedValues = {setSelectedValues},
        reportStartPage,
        setReportStartPage,
        fetchReports,
        ceid
    } = props;

    tableDataBackup = reportsdata

    const API = useAxios();
    const [state, updateState] = useState({
        filters: filters,
    });

    const toggleSider = async () => {
        await manval();
    }

    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();
    }

    const handleonExport = () => {
        onExport()
    }

    const renderEditButton = (rowData) => {
        // if (hasPermission('EDT'))
        return( <><Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleExport(rowData)}
            title="Download report">
            <HoverImage src={Download}
                hoverSrc={DownloadHover}
                alt='' />
        </Button>
        {rowData.statusDesc === "Uploaded" &&
         <Button
          className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleAutosendReports(rowData)}
            title={(rowData.reportTypeID == 7 || rowData.reportTypeID == 8) ? "Download Beacon Pharmacy report" : "Download ESP report"}>
             <HoverImage src={Autosend}
                hoverSrc={AutosendHover}
                alt='' />
        </Button>
    }
        </>)
    }

    const handleExport = async (rowData) => {
        try {
            if(rowData.recordCount > 0){
            const response = await API.get(`api/Report/download/${rowData?.encryptedReportDetailsID}`, {
                hasDefaultURL: true,
                responseType: 'blob'
            },
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${rowData.fileName}`);
            document.body.appendChild(link);
            link.click();
        }
        else{
            toast.error('No Records Found')
        }
        } catch (error) {
            console.log(error);
        }
    };

    const handleAutosendReports = async (rowData) => {
        try {
            if(rowData.statusDesc === "Uploaded"){
            const response = await API.get(`api/Report/downloadOutFile/${rowData?.encryptedReportDetailsID}`, {
                hasDefaultURL: true,
                responseType: 'blob'
            },
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${rowData.fileName}`);
            document.body.appendChild(link);
            link.click();
        }
        } catch (error) {
            console.log(error);
        }
    };
       

    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {/* {renderConfigButton(rowData)} */}
                {renderEditButton(rowData)}
                {/* {renderCommentsButton(rowData)} */}
                {/* {renderViewButton(rowData)} */}
            </div>
        );
    };

    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) =>
                cellRenderEdit(rowData),
            width: 100,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'reportName',
            text: 'Report Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.reportName),
        },
        {
            dataField: 'reportTypeName',
            text: 'Report Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.reportTypeName),
        },
        {
            dataField: 'fileName',
            text: 'File Name',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.fileName),
        },
        {
            dataField: 'recordCount',
            text: 'No. of Records',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.recordCount == 0 ? "0" : row.recordCount),
        },
        {
            dataField: 'statusDesc',
            text: 'Report Status',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.statusDesc),
        },
        {
            dataField: 'retryCount',
            text: 'Retry Count',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.retryCount == 0 ? "0" : row.retryCount),
        },
        {
            dataField: 'dateGenerated',
            text: 'Data Generated',
            sort: true,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.dateGenerated),
        },

    ];

    const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
            setSort(true)
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const filterslist = [
        {
            filterType: "List",
            filterName: "Status",
            filterdataFiled: "statusDesc",
            filterOptions: [
                {
                    "id": "1",
                    "label": "Inprogress"
                },
                {
                    "id": "2",
                    "label": "Generated",

                },
                {
                    "id": "3",
                    "label": "Generated Failed",
                },
                {
                    "id": "4",
                    "label": "No Data",
                },
                {
                    "id": "5",
                    "label": "Uploaded",
                },
                {
                    "id": "6",
                    "label": "Uploaded Failed",
                }
            ]
        }
    ]

    const onHandelFilterChange = (filter, hasColFilter) => {
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
        filters.currentPage = 1
    }

    return (
        <div>
            {/* {loading&&<Loader opacity={0.01}color='black'/>} */}
            <div className="d-flex justify-content-between section-devider-border pb-2">
                <h3 className='font-20'>Search Results
                    {totalSize > 0 &&
                        <span className='f-18 text-primary font-weight-700 ms-1'>({totalSize})</span>}
                </h3>
                <span style={{ cursor: "pointer" }} onClick={toggleSider}>
                    <img collapseSider src={!collapseSider ? collapse : collapseclose} className="" />
                </span>
            </div>
            <div>
                <Filters filterslist={filterslist}
                    onHandelFilterChange={onHandelFilterChange}
                    filters={filters}
                    onSearch={onSearch}
                    filtershow={filtershow}
                    setFilterShow={setFilterShow}
                    setStartPage={setReportStartPage}
                    data={reportsdata}
                    fetchReports={fetchReports}
                    selectedValues={selectedValues}
                    setSelectedValues={setSelectedValues}
                    totalRecords={totalSize}
                    ceid={ceid}
                // resetFilter={resetFilter}
                //setResetFilter={setResetFilter} 
                />
            </div>
            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={(reportsdata && reportsdata.length > 0)? 'fixed-height' : 'default'}
            >

                <ReactStrapTable
                    id='configuration-table'
                    height={550}
                    fixedColumn
                    width={1200}
                    // reset={reset}
                    data={reportsdata}
                    columns={mainCol}
                    handelAddCoveredEntity={handelAddCoveredEntity}
                    onExport={handleonExport}
                    filters={filters}
                    totalRecords={totalSize}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    hasExportPermission={true}
                    startPage={reportStartPage}
                    setStartPage={setReportStartPage}
                    // collapseSider={collapseSider}
                    isReportConfiguration={true}
                    toggleSider={toggleSider}
                    handleSort={handleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    hasDefaultPagination={true}
                    sort={sort}
                    setSort={setSort}

                />
            </div>
        </div>
    )
}

export default ReportsTable;